<!-- TEMPLATE
<SnackBarNotifier
  :isShow="isShowSnackBar" //Required
  :message="responseMessage" //Required
  @eReset="resetSnackBar" //Required
/>
___________________________________________
import SnackBarNotifier from "@/components/widgets/SnackBarNotifier.vue";

methods: {
  showNotifier(message) {
    this.isShowSnackBar = true;
    this.responseMessage = message;
  },
  resetSnackBar(){
    this.isShowSnackBar = false;
  }
}-->

<template>
  <div @mouseover="mouseOverSnackBar" @mouseleave="mouseLeaveSnackBar">
    <v-snackbar
      v-model="showSnackBar"
      :color="
        messageHasSuccessIdentifier
          ? 'green darken-2 white--text'
          : 'red darken-2 white--text'
      "
      :timeout="localTimeOut"
    >
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="black"
          text
          v-bind="attrs"
          @click="loadingBtnOperation"
          :disabled="loading"
        >
          <v-progress-circular
            v-if="loading"
            indeterminate
            size="28"
            width="3"
            color="white"
          ></v-progress-circular>
          <div v-if="!loading">
            {{ messageHasSuccessIdentifier ? "Close" : buttonTitle }}
          </div>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      Type: Boolean,
      Required: true
    },
    message: {
      Type: String,
      Required: true
    },
    //If {successIdentifier} is found in {message}, snackbar colour is  green, else red.
    successIdentifier: {
      Type: String,
      default() {
        return "Successfully";
      }
    },
    timeout: {
      Type: String,
      default() {
        return "5000";
      }
    },
    //Able to override button title, only shown on error
    buttonTitle: {
      Type: String,
      default() {
        return "Close";
      }
    },
    //Able to override button operation when an error occur
    buttonOperation: {
      Type: Function,
      default() {
        return () => this.closeSnackBar();
      }
    }
  },
  data() {
    return {
      loading: false,
      localTimeOut: this.timeout
    };
  },
  computed: {
    showSnackBar: {
      get() {
        return this.isShow;
      },
      set() {
        //Need to update {showSnackBar} value on caller page
        this.$emit("eReset");
      }
    },
    messageHasSuccessIdentifier() {
      return this.message.includes(this.successIdentifier);
    }
  },
  methods: {
    async loadingBtnOperation() {
      try {
        this.loading = true;
        this.messageHasSuccessIdentifier
          ? this.closeSnackBar()
          : await this.buttonOperation();
        this.closeSnackBar();
        this.loading = false;
      } catch (err) {
        this.$logger.error(err);
      }
    },
    closeSnackBar() {
      this.showSnackBar = false;
    },
    mouseOverSnackBar() {
      this.localTimeOut = -1;
    },
    mouseLeaveSnackBar() {
      this.localTimeOut = this.timeout;
    }
  }
};
</script>
